import { render, staticRenderFns } from "./AudioToolbar.vue?vue&type=template&id=3053d1df&scoped=true"
import script from "./AudioToolbar.vue?vue&type=script&lang=js"
export * from "./AudioToolbar.vue?vue&type=script&lang=js"
import style0 from "./AudioToolbar.vue?vue&type=style&index=0&id=3053d1df&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3053d1df",
  null
  
)

export default component.exports